import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as _ from 'lodash';
import {Provider} from 'react-redux';

import {connect} from 'react-redux';


/**
 *
 * @param selector string for select element by id or classname. if no prefix is specify, then selector is default to className.
 * @param Component
 * @param store if store is null, no provider will be created
 * @param parameters
 */
let renderComponent = (selector: string, Component: any, store?, parameters = {}) => {
    let elements;
    let isId = selector.match(/^#/g);
    let noPrefixSelector = selector.substring(1);
    if (isId) {
        var element = document.getElementById(noPrefixSelector);
        if (element) {
            elements = [element];
        } else {
            // console.log("renderComponent id miss", selector);
            return;
        }
    } else {
        let hasClassPrefix = selector.match(/^\./g);
        elements = document.getElementsByClassName(hasClassPrefix? noPrefixSelector : selector);
        if (!elements.length) {
            // console.log("renderComponent class miss", selector);
            return;
        }
    }

    _.forEach(elements,el => {
        ReactDOM.render(store ?
            <Provider store={store}>
                <Component {...el.dataset} {...parameters} />
            </Provider>
            :
            <Component {...el.dataset} {...parameters}/>,
        el)
    });
};

export {renderComponent}


export function connectComponent(state, props, component) {
    return connect<{}, any, any>(state, props)(component);
}

export const getDisplayName = (Component, defaultName = 'Component') => Component.displayName || Component.name || defaultName;



// WEBPACK FOOTER //
// ./resources/modules/shared/utilities/ReactUtils.tsx